document.querySelectorAll('.js-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
        const parent = btn.closest('.access-toggle');
        const content = parent.querySelector('.js-toggle-content');

        const isOpen = parent.classList.contains('is-open');

        if (isOpen) {
            // 閉じる
            content.style.height = content.scrollHeight + 'px';
            requestAnimationFrame(() => {
                content.style.height = '0px';
            });

            parent.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');

        } else {
            // 開く
            content.style.height = content.scrollHeight + 'px';

            content.addEventListener('transitionend', function handler() {
                content.style.height = 'auto';
                content.removeEventListener('transitionend', handler);
            });

            parent.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
        }
    });
});